// ** Redux
import { vendor } from "store/vendor";
import { clearUserSuspension, setUserSuspension } from "store/modules/user";

// #####################################################

export default function updateSuspensionHeader(headers) {
	const header = headers ? headers["datezone-user-ban"] || null : null;

	if (header == null) {
		return;
	}

	const suspension = JSON.parse(Buffer.from(header, "base64").toString());
	const isBanFromState = vendor.store.getState().user.suspension.duration > 0;

	if (!suspension.isBan && isBanFromState) {
		vendor.store.dispatch(clearUserSuspension());
		return;
	}

	if (suspension.banTo) {
		vendor.store.dispatch(
			setUserSuspension(
				suspension.banTo,
				suspension.banType,
				suspension.id,
				suspension?.isBanForNewContent
			)
		);
	}
}

// #####################################################
